import { ProtectedRouteUser, ProtectedRouteWorkspace } from '@/app/guards';
import { AgentPage } from '@/app/router/lazyPages';
import { logger } from '@/shared/helpers/logger';
import { AppErrorFallback } from '@/view/shared/Fallback';
import type React from 'react';
import { ErrorBoundary } from 'react-error-boundary';

export function AgentRoute(): React.JSX.Element {
  return (
    <ProtectedRouteUser needToExist={true}>
      <ProtectedRouteWorkspace>
        <ErrorBoundary
          onError={(error) =>
            logger.error('Agent ErrorBoundary caught error', { error, log_source: 'Agent' })
          }
          FallbackComponent={AppErrorFallback}
        >
          <AgentPage />
        </ErrorBoundary>
      </ProtectedRouteWorkspace>
    </ProtectedRouteUser>
  );
}
